"use client";

import { ErrorFallbackContent } from "#app/_ui/components/errors/error-fallback";
import { bodyVariants, rootVariants } from "#ui/root.styles";

import "#ui/globals.css";

export default function GlobalError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  return (
    <html lang="en" className={rootVariants()}>
      <body className={bodyVariants()} suppressHydrationWarning>
        <main className="grid grow place-items-center bg-banner bg-[url('/Images/banner-bg.jpg')] bg-cover bg-center bg-no-repeat p-20px text-white md:p-30px">
          <ErrorFallbackContent
            error={error}
            onClickRetry={retry}
            className="w-full max-w-600px text-shade-100"
          />
        </main>
      </body>
    </html>
  );
}
